// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__27xT3","actions":"GroupTable_actions__2hYvH","deleteModalFooter":"GroupTable_deleteModalFooter__M2ryZ"};